// plugins/vidle.client.ts
import { defineNuxtPlugin } from '#app';
import Vidle from 'v-idle-3';

export default defineNuxtPlugin((nuxtApp) => {
    // this is exactly the same as `app.use(Vidle)` in a plain Vue app
    nuxtApp.vueApp.use(Vidle);
});